import React from "react";

function Chapter11() {
  return (
    <>
      <div className="chapter-container">

        <h1 className="chapter-title">
          A<span className="fix4">4</span>H PAC Kansas Chapter
        </h1>

        <h3 className="leader">President: Seema Lokre</h3>

        <h4 className="section-title">About the Chapter</h4>

        <p>
          The A4H PAC Kansas Chapter is a proud branch of Americans4Hindus PAC,
          dedicated to strengthening Hindu political representation and ensuring
          that Hindu-American voices are heard at every level of governance.
        </p>

        <p>Our chapter works tirelessly to:</p>

        <ul>
          <li>Build awareness of civic responsibilities among Hindu-Americans.</li>
          <li>Encourage active participation in local, state, and national politics.</li>
          <li>Support leaders and candidates who uphold Hindu values of dharma, equality, and unity.</li>
          <li>Create a platform for dialogue, collaboration, and community advancement.</li>
        </ul>

        <p>
          Together, we are shaping a future where the Hindu community plays a
          meaningful role in America’s political landscape.
        </p>

        <h4 className="section-title">Our Mission</h4>

        <p>
          Our mission is to empower Hindu-Americans in Kansas to engage
          meaningfully in civic and political life not only as voters, but as
          leaders, policymakers, and changemakers.
        </p>

        <p>
          Through community mobilization, policy education, and leadership
          development, A4H PAC Kansas Chapter seeks to:
        </p>

        <ul>
          <li>Support Hindu candidates running for public office.</li>
          <li>Advocate for issues important to the Hindu community.</li>
          <li>Educate members about local and national political processes.</li>
          <li>Build alliances with other faith and cultural organizations to promote unity.</li>
        </ul>

        <p>
          We believe that when Hindus participate in politics, America becomes
          stronger, more inclusive, and more just.
        </p>

        <h4 className="section-title">Events & Activities</h4>

        <p>Our chapter regularly organizes:</p>

        <ul>
          <li>Town halls and political forums with elected officials and candidates.</li>
          <li>Leadership development workshops to prepare young Hindu-Americans for public service.</li>
          <li>Community service drives highlighting Hindu values of seva (selfless service).</li>
          <li>Fundraising galas and policy discussions in support of the A4H PAC mission.</li>
        </ul>

        <p>
          Upcoming events will be updated{" "}
          <a href="about:blank">here</a> periodically.
        </p>

        <p>
          We welcome all Hindu-Americans in Kansas to become active members of our movement.
        </p>

        <p>
          Your participation helps us expand our reach, advocate effectively, and support Hindu leaders in public life.
        </p>

      </div>

      <style>{`

.chapter-container{
  width:100%;
  padding:40px 80px;
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
  font-family: 'Poppins', sans-serif !important;
  box-sizing:border-box;
}

.chapter-container p,
.chapter-container li{
  font-size:16px !important;
  line-height:1.6 !important;
  font-weight:400 !important;
  font-family: 'Poppins', sans-serif !important;
}

.chapter-container ul{
  list-style-type: disc;
  margin-left:20px;
  padding-left:0;
}

.chapter-container li{
  margin:6px 0;
}

.chapter-title{
  text-align:center;
  font-size:42px !important;
  font-weight:700 !important;

  background: linear-gradient(90deg, #c4002f, #ff6a6a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-family: 'Playfair Display', serif !important;

  letter-spacing: 3px;
  text-transform: uppercase;

  text-shadow: 1px 1px 5px rgba(0,0,0,0.15);

  margin-bottom:40px;
}

.fix4{
  font-size: inherit !important;
  font-weight:700;
}

.leader{
  font-size:22px !important;
  font-weight:bold !important;
  color:#0b3d6d;
  margin-bottom:10px;
  text-transform:uppercase;
}

.section-title{
  margin-top:25px;
  font-weight:bold !important;
  font-size:18px !important;
}

.chapter-container p{
  margin:10px 0;
}

.chapter-container a{
  color:blue !important;
  text-decoration:underline;
}

.chapter-container a:visited{
  color:blue !important;
}

.chapter-container a:hover{
  color:darkblue !important;
}

      `}</style>
    </>
  );
}

export default Chapter11;